// extracted by mini-css-extract-plugin
module.exports = {"contentwrapper":"EditCoinForm_contentwrapper__3bfHJ","image":"EditCoinForm_image__2evQQ","BackButton":"EditCoinForm_BackButton__23eFS","TopTitle":"EditCoinForm_TopTitle__2Rxxt"};